import i18n from 'services/base/i18n';

export default {
  // Title of the page informing the user of the rename step
  title: () => i18n.pgettext('Pages|Add Pangolin|Rename', 'Give your Pangolin a unique name'),

  // Description on the requirement of this step
  instructions: () => i18n.pgettext('Pages|Add Pangolin|Rename', 'Your Pangolin deserves to have a name of its own'),

  // Instructions for the user to provide a name to their device
  nickname: () => i18n.pgettext('Pages|Add Pangolin|Rename', 'Pangolin Name'),

  // Text for the link to continue to the next page
  next: () => i18n.pgettext('Pages|Add Pangolin|Rename', 'NEXT'),
};
